// extracted by mini-css-extract-plugin
module.exports = {"backgroundColor":"rgba(29,29,27,.9)","borderColor":"#61615f","tooltip":"Tooltip_tooltip__Gfbdr"};